export enum EnumWorkflowEmailState {
  PrintWorkflowSummary = 2,
}
